import { useTranslations } from 'next-intl';

import type { AlertModalProps } from '@/types/modal';

import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '../ui/alert-dialog';

function AlertModal(props: AlertModalProps) {
  const translate = useTranslations();

  const {
    title,
    continueText,
    open,
    onOpenChange,
    description,
    onCancel,
    onContinue,
    className,
    children,
  } = props;

  const finalContinueText = continueText ?? translate('modal.continue');

  return (
    <AlertDialog onOpenChange={onOpenChange} open={open}>
      <AlertDialogContent className={className}>
        <AlertDialogHeader>
          {title && <AlertDialogTitle>{title}</AlertDialogTitle>}
          {description && (
            <AlertDialogDescription>{description}</AlertDialogDescription>
          )}
          {children}
        </AlertDialogHeader>
        <AlertDialogFooter>
          {onCancel && (
            <AlertDialogCancel
              onClick={() => {
                onCancel();
              }}
            >
              Cancel
            </AlertDialogCancel>
          )}
          {onContinue && (
            <AlertDialogAction
              onClick={() => {
                onContinue();
              }}
            >
              {finalContinueText}
            </AlertDialogAction>
          )}
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}

export default AlertModal;
